import css from "styled-jsx/css";
import { PLANS_COMPONENT_WIDTH } from "constants/pricing-sizes";

export const componentStyles = css`
  .features-table-pricing-component {
    width: ${`${PLANS_COMPONENT_WIDTH}px`};
    margin: 0 auto;
  }
`;
